import type { StepState, WizardStore } from "./types";
import defaultManifest from "../../shared/libs/workflow-engine/default-manifest.json";

/**
 * Build wizard store default state from the workflow manifest.
 * Each step path becomes a key with { valid: false }.
 * The shared get-started step is pre-marked as submitted for every category so
 * that wizardApi.reset() (fired on GetStartedPage/ServiceSelector mount when
 * going back) never causes PageLayout to redirect back to /get-started.
 */
function buildDefaultState(): WizardStore {
  const state: Record<string, Record<string, StepState>> = {};
  const getStartedPath = defaultManifest.sharedSteps?.getStarted?.path;

  for (const [category, steps] of Object.entries(
    defaultManifest.serviceCategories,
  )) {
    state[category] = {};
    // Pre-mark the shared get-started step as submitted.
    // It lives in sharedSteps (not serviceCategories) so the loop below never
    // reaches it, but useDynamicSteps prepends it to categorySteps. Without
    // this, the key is missing after reset and lastReachedStep points to
    // get-started, triggering a redirect loop from any category step.
    if (getStartedPath) {
      state[category][getStartedPath] = { valid: false, submitted: true };
    }
    for (const step of steps) {
      state[category][step.path] = { valid: false };
    }
  }

  return state as WizardStore;
}

export const defaultState: WizardStore = buildDefaultState();
